import React from 'react';
import styles from '../olavotattoo/olavotattoo.module.scss';
import Perfil from './src/perfil.png';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import HallIcon from '../../icons/hallIcon.tsx';
import TattooIcon from '../../icons/tattooIcon.tsx';

const Olavotattoo: React.FC = () => {

    return (
        <div className={styles.olavotattoo}>
            <div className={styles["body-thunder"]}>
                <div className={`${styles["container-thunder"]}`} >
                    <img className={styles["img-perfil"]} src={Perfil} />
                    <div className="mb-3">
                        <a className="pe-1" href="https://wa.me/5517991949525?text=Olá, gostaria de mais informações..." target="_blank">
                            <WhatsappIcon height="36" color="#ffffff" />
                        </a>
                        <a className="ps-1" href="https://www.instagram.com/olavotattoo?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank">
                            <InstagramIcon height="29" color="#ffffff" />
                        </a>
                    </div>
                    <div className={styles.links}>
                        {/* <LinkPersonalizado7
                            href="https://www.instagram.com/olavotattoo?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="INSTAGRAM"
                            icon={<InstagramIcon height="32" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="https://wa.me/5517992054737?text=Olá, gostaria de mais informações..."
                            title="WHATSAPP"
                            icon={<WhatsappIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                        /> */}
                        <LinkPersonalizado7
                            href="https://maps.app.goo.gl/FyBQsxJGcyNZxd5J7"
                            title="LOCALIZAÇÃO"
                            icon={<MapsIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="/olavotattoo/estudio"
                            title="ESTÚDIO"
                            icon={<HallIcon height="36" color="#ffffff" />}
                            colorText="#cbb353"
                            linkInterno={true}
                        />
                        <LinkPersonalizado7
                            href="/olavotattoo/tattoo"
                            title="TATTOO"
                            icon={<TattooIcon height="36" color="#ffffff" />}
                            colorText="#cbb353"
                            linkInterno={true}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Olavotattoo;
